import { createSlice } from '@reduxjs/toolkit';

const initialState = {
    lastname: '',   //фамилия
    name: '',   //имя
    patronymic: '', //отчество
    birthdate: new Date(),  //дата рождения
    birthDateString: '01-01-2000',
    gender: '',    //пол
    height: '', //рост
    weight: '', //вес
    document: '',   //документ
    serialAndNumber: '',    //серия и номер
    dateOfIssue: new Date(),    //дата выдачи
    issueDateString: '',
    subdivisionCode: '',    //код подразделения
    issuedBy: '',   //кем выдан
    registrationAdress: '', //адрес регистрации
    fiasIdRegAddr: '',
    kladrIdRegAddr: '',
    arteryUpperPressure: '100 - 135',    //артериальное верхнее давление
    arteryBottomPressure: 'до 95',   //артериальное нижнее давление
    smoking: 'Не курю', //курит
    alcohol: 'Не пью', //пьет
    workingPlaceName: '',   //имя организации в которой работает
    position: 'Менеджер',   //должность
    profession: 'Аналитик', //профессия
    newestBuilding: false,  //новостройка
    publicPerson: false //публичное лицо
}

export const personSlice = createSlice({
    name: 'person',
    initialState,
    reducers: {
        setBirthDateString: (state, action) => {
            state.birthDateString = action.payload
        },
        setIssueDateString: (state, action) => {
            state.issueDateString = action.payload
        },
        setKladrIdRegAddr: (state, action) => {
            state.kladrIdRegAddr = action.payload
        },
        setFiasIdRegAddr: (state, action) => {
            state.fiasIdRegAddr = action.payload
        },
        setLastname: (state, action) => {
            state.lastname = action.payload
        },
        setName: (state, action) => {
            state.name = action.payload
        },
        setPatronymic: (state, action) => {
            state.patronymic = action.payload
        },
        setBirthDate: (state, action) => {
            state.birthdate = action.payload
        },
        setSex: (state, action) => {
            state.gender = action.payload
        },
        setHeight: (state, action) => {
            state.height = action.payload
        },
        setWeight: (state, action) => {
            state.weight = action.payload
        },
        setDocument: (state, action) => {
            state.document = action.payload
        },
        setSerial: (state, action) => {
            state.serialAndNumber = action.payload
        },
        setIssueDate: (state, action) => {
            state.dateOfIssue = action.payload
        },
        setSubdivision: (state, action) => {
            state.subdivisionCode = action.payload
        },
        setIssuedBy: (state, action) => {
            state.issuedBy = action.payload
        },
        setRegAdr: (state, action) => {
            state.registrationAdress = action.payload
        },
        setArteryUp: (state, action) => {
            state.arteryUpperPressure = action.payload
        },
        setArteryBott: (state, action) => {
            state.arteryBottomPressure = action.payload
        },
        setSmoking: (state, action) => {
            state.smoking = action.payload
        },
        setAlcohol: (state, action) => {
            state.alcohol = action.payload
        },
        setWorkingPlace: (state, action) => {
            state.workingPlaceName = action.payload
        },
        setPosition: (state, action) => {
            state.position = action.payload
        },
        setProfession: (state, action) => {
            state.profession = action.payload
        },
        setIsNewest: (state, action) => {
            state.newestBuilding = action.payload
        },
        setIsPublicPerson: (state, action) => {
            state.publicPerson = action.payload
        }
    }
})

export const {
    setBirthDateString,
    setIssueDateString,
    setLastname,
    setFiasIdRegAddr,
    setKladrIdRegAddr,
    setName,
    setPatronymic,
    setBirthDate,
    setSex,
    setHeight,
    setWeight,
    setDocument,
    setSerial,
    setIssueDate,
    setSubdivision,
    setIssuedBy,
    setRegAdr,
    setArteryUp,
    setArteryBott,
    setSmoking,
    setAlcohol,
    setWorkingPlace,
    setPosition,
    setProfession,
    setIsNewest,
    setIsPublicPerson
} = personSlice.actions

export const selectBirthDateString = (state) => state.person.birthDateString
export const selectIssueDateString = (state) => state.person.issueDateString
export const selectLastname = (state) => state.person.lastname
export const selectName = (state) => state.person.name
export const selectPatronymic = (state) => state.person.patronymic
export const selectBirthDate = (state) => state.person.birthdate
export const selectSex = (state) => state.person.gender
export const selectHeight = (state) => state.person.height
export const selectWeight = (state) => state.person.weight
export const selectDocument = (state) => state.person.document
export const selectSerial = (state) => state.person.serialAndNumber
export const selectIssueDate = (state) => state.person.dateOfIssue
export const selectSubdivision = (state) => state.person.subdivisionCode
export const selectIssuedBy = (state) => state.person.issuedBy
export const selectRegAdr = (state) => state.person.registrationAdress
export const selectArteryUp = (state) => state.person.arteryUpperPressure
export const selectArteryBott = (state) => state.person.arteryBottomPressure
export const selectSmoking = (state) => state.person.smoking
export const selectAlcohol = (state) => state.person.alcohol
export const selectWorkingPlace = (state) => state.person.workingPlaceName
export const selectPosition = (state) => state.person.position
export const selectProfession = (state) => state.person.profession
export const selectIsNewest = (state) => state.person.newestBuilding
export const selectIsPublicPerson = (state) => state.person.publicPerson

export const selectFiasIdRegAddr = (state) => state.person.fiasIdRegAddr
export const selectKladrIdRegAddr = (state) => state.person.kladrIdRegAddr

export default personSlice.reducer

